import {
  AodRule,
  AodRuleReportTypeEnum,
  AodRun,
  CreateAodRuleDto,
} from '@app/modules/audit/modules/aod/aod.types';
import { ComponentType } from 'react';
import { AodRuleWizardCompletedValues } from '../types';
import { useGipAltAodFactory } from './gip-alt/GipAltAodFactory';
import { useGipAodFactory } from './gip/GipAodFactory';

export interface AodRunActionsProps {
  run: AodRun;
  display?: 'short' | 'long';
}

export interface AodReportFactory<
  Values extends AodRuleWizardCompletedValues = AodRuleWizardCompletedValues<any, any, any>,
  CreateDto extends CreateAodRuleDto = CreateAodRuleDto,
  RuleDto extends AodRule = AodRule,
> {
  fields: {
    ExportConditions?: ComponentType<any>;
  };
  wizardForms: {
    ReportConfig: ComponentType<any>;
    ExportOptions?: ComponentType<any>;
    ExportConditions?: ComponentType<any>;
  };
  views: {
    ReportConfig: ComponentType<{ reportConfig: CreateDto['reportConfig'] }>;
    ExportOptions?: ComponentType<{
      exportOptions: CreateDto['exportOptions'];
    }>;
    ExportConditions?: ComponentType<{
      exportConditions: CreateDto['exportConditions'];
    }>;
    RunDataPreview?: ComponentType<{
      data: Pick<AodRun, 'overrideReportConfig'>;
    }>;
    RunActions?: ComponentType<AodRunActionsProps>;
  };
  valuesToApi: (values: Values) => CreateDto;

  // if the values are loading, null will be returned
  apiToValues: (rule: RuleDto) => Values | null;
}

export function useAodFactory(reportType: string): AodReportFactory {
  const results = {
    [AodRuleReportTypeEnum.AUDIT_GIP_STATUS]: useGipAodFactory(),
    [AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT]: useGipAltAodFactory(),
  };

  switch (reportType) {
    case AodRuleReportTypeEnum.AUDIT_GIP_STATUS:
      return results[AodRuleReportTypeEnum.AUDIT_GIP_STATUS] as unknown as AodReportFactory;

    case AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT:
      return results[
        AodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT
      ] as unknown as AodReportFactory;

    default:
      throw new Error(`Unsupported report type: ${reportType}`);
  }
}
